import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import { Instagram, Facebook, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})).catch(() => {}); }, []);

  return (
    <footer className="bg-[#4A3B40] text-[#F9E1E8] mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="inline-block"><Logo size="lg" /></div>
          <p className="mt-4 text-sm text-[#F9E1E8]/80 leading-relaxed">
            Acessórios infantis delicados, feitos com carinho para encantar bebês e meninas em todos os momentos especiais.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={`https://instagram.com/${(s.instagram||'').replace('@','')}`} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#E8A0B4]/30 flex items-center justify-center hover:bg-[#E8A0B4] transition-colors" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-[#E8A0B4]/30 flex items-center justify-center hover:bg-[#E8A0B4] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={`mailto:${s.email||'contato@larab.com.br'}`} className="w-9 h-9 rounded-full bg-[#E8A0B4]/30 flex items-center justify-center hover:bg-[#E8A0B4] transition-colors">
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div>
          <h4 className="font-serif text-lg font-semibold mb-3 text-white">Institucional</h4>
          <ul className="space-y-2 text-sm text-[#F9E1E8]/80">
            <li><a href="/paginas/sobre" className="hover:text-white">Sobre a Lara B.</a></li>
            <li><a href="/paginas/trocas" className="hover:text-white">Trocas e Devoluções</a></li>
            <li><a href="/paginas/frete" className="hover:text-white">Frete e Prazos</a></li>
            <li><a href="/paginas/privacidade" className="hover:text-white">Política de Privacidade</a></li>
            <li><a href="/paginas/termos" className="hover:text-white">Termos de Uso</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg font-semibold mb-3 text-white">Atendimento</h4>
          <ul className="space-y-2 text-sm text-[#F9E1E8]/80">
            <li>{s.email || "contato@larab.com.br"}</li>
            <li>WhatsApp: {s.whatsapp ? `+${s.whatsapp}` : "+55 81 99999-9999"}</li>
            <li>Seg a Sex, 9h às 18h</li>
            <li>{s.address || "Recife, PE"}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg font-semibold mb-3 text-white">Formas de pagamento</h4>
          <div className="flex flex-wrap gap-2 text-xs">
            {["PIX", "Visa", "Master", "Elo", "Hiper", "Amex", "Boleto"].map((t) => (
              <span key={t} className="bg-white/10 border border-white/20 px-2 py-1 rounded">{t}</span>
            ))}
          </div>
          <p className="text-xs text-[#F9E1E8]/60 mt-4">CNPJ: {s.cnpj || "00.000.000/0001-00"}</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-[#F9E1E8]/60">
        © {new Date().getFullYear()} Lara B. — Feito com carinho em Recife, PE
      </div>
    </footer>
  );
}
